import React from 'react';

export enum AEyebrowVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface AEyebrowProps extends React.HTMLAttributes<HTMLElement> {
  eyebrowText?: string;
  children?: React.ReactNode;
  variant?: AEyebrowVariant;
}
